import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { MobileBottomNav } from "./MobileBottomNav";
import { MobileAppBar } from "./MobileAppBar";
import { MobileDrawer } from "./MobileDrawer";
import { GlobalSearch } from "../common/GlobalSearch";
import { useAuth } from "../../context/AuthContext";
import { Toaster } from "../ui/sonner";

export const MainLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#ED1C24]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Desktop Sidebar */}
      <Sidebar />
      
      {/* Desktop Top Bar with Search */}
      <div className="hidden md:flex fixed top-0 right-0 left-64 h-14 bg-white border-b border-gray-200 items-center justify-between px-6 z-40">
        <GlobalSearch className="flex-1 max-w-xl" />
        <div className="flex items-center gap-2 ml-4">
          {/* Additional header actions can go here */}
        </div>
      </div>
      
      {/* Mobile Navigation */}
      <MobileAppBar onMenuClick={() => setDrawerOpen(true)} />
      <MobileBottomNav onMenuClick={() => setDrawerOpen(true)} />
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      
      {/* Main Content */}
      <main className="main-content" data-testid="main-content">
        {/* Add padding for desktop top bar, mobile top bar and bottom nav */}
        <div className="pt-14 md:pt-14 pb-20 md:pb-0" style={{ paddingBottom: 'calc(80px + env(safe-area-inset-bottom, 0px))' }}>
          <div className="p-4 md:p-6">
            <Outlet />
          </div>
        </div>
      </main>
      
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default MainLayout;
